import { AuthService } from './modules/auth/services/auth.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {
  Router,
  RouterEvent,
  RouteConfigLoadStart,
  RouteConfigLoadEnd
} from '@angular/router';
import { AlertsService, LanguageService } from 'itcores-fw';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { CryptoUtils, Logger } from 'msal';
import { AuthTypeEnum } from './modules/auth/models/auth-type-enum';
import { AppUrls } from './modules/core/helpers/app-urls';
import { environment } from '@environments/environment';

import * as workerTimers from 'worker-timers';
import Swal from 'sweetalert2';
import { switchMap } from 'rxjs/operators';
import { EventMessage, EventType } from '@azure/msal-browser';
import { EMPTY, of } from 'rxjs';
declare let layout: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  /* #region  Fields & Properties */
  isIframe = false;
  loggedIn = false;
  private timerInterval: any;
  private lastActiveDateKey = environment.timerKey;
  private maxIdleTimeKey = environment.maxIdleTimeKey;
  showSessionTimeOutPopPup: boolean;
  sessionCountDownTimerInMinutes = environment.sessionCountDownTimerInMinutes;
  interval: number;
  progressValue = 0;
  @ViewChild('spinnerComponent', { static: false }) spinnerComponent: ElementRef;

  private get idleTimeInMinutes() {
    var lastActiveDateKeyBase64 = localStorage.getItem(this.lastActiveDateKey)
    var lastActiveDate = lastActiveDateKeyBase64 ? new Date(parseInt(atob(lastActiveDateKeyBase64))) || new Date() : new Date();
    return Math.floor((Math.abs(new Date(lastActiveDate).valueOf() - new Date().valueOf()) / 1000) / 60);
  }

  private set idleTimeInMinutes(value: number) {
    var date = btoa(new Date().valueOf().toString())
    localStorage.setItem(this.lastActiveDateKey, date);
  }

  get maxIdleTime() {
    return Number(localStorage.getItem(this.maxIdleTimeKey) || 0) || 0;
  }

  set maxIdleTime(value: number) {
    localStorage.setItem(this.maxIdleTimeKey, (value || environment.maxIdleTime).toString());
  }

  get totalIdleTimeForUser() {
    return Number(this.maxIdleTime) + Number(this.sessionCountDownTimerInMinutes);
  }
  /* #endregion */

  /* #region  Constructor */
  constructor(
    private router: Router,
    public alertsService: AlertsService,
    private authService: AuthService,
    private _language: LanguageService,
    // private swUpdates: SwUpdate,
    private broadcastService: MsalBroadcastService,
    private msalService: MsalService,
  ) {
    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === 'clearSessionNow') {
        this.cleanTimerSettings();
        this.startTimer();
      }
    });

    window.addEventListener("online", () => {
      if (this.idleTimeInMinutes < this.maxIdleTime) {
        this.alertsService.successMessage(this._language.Lang === 'ar' ?
          'انت الان متصل بالانترنت' :
          'Now , you are connected', true);
      }
    });
    window.addEventListener("offline", () => {
      if (this.idleTimeInMinutes < this.maxIdleTime) {
        this.alertsService.errorMessage(this._language.Lang === 'ar' ?
          'لقد فقدت اتصالك بالانترنت' :
          'You lost your internet connection');
      }
    });
  }
  /* #endregion */

  /* #region  Events */
  ngOnInit() {
    layout();
    this.isIframe = window !== window.parent && !window.opener;
    this.checkoutAccount();
    this.initializeSession();
    this.broadcastService.msalSubject$
      .pipe(
        switchMap((msg: EventMessage) => {
          switch (msg.eventType) {
            case EventType.LOGIN_SUCCESS:
              this.checkoutAccount();
              return of(this.router.navigate([AppUrls.landing]));

            case EventType.LOGIN_FAILURE:
              return of(this.authService.goToLogin());

            case EventType.ACQUIRE_TOKEN_FAILURE:
              if (this.authService.getAuthType() === AuthTypeEnum.OIDC) {
                return of(this.authService.goToLogin());
              }

              return EMPTY;
          }
        })
      )
      .subscribe();
    /*
        this.broadcastService.subscribe('msal:loginSuccess', () => {
          // Go to dashboard
          // this.checkoutAccount(); // Return wen microsoft login back again
    
          // TODO - convert Microsoft token to JWT token
          const idToken = localStorage.getItem('msal.idtoken');
          this.authService.getJwtTokenFromMicrosoftToken(idToken)
            .subscribe(res => {
              this.msalService.clearCacheForScope(idToken);
              if (res && res.status) {
                this.authService.saveArcoToken(res.authToken);
                this.authService.setAuthType(AuthTypeEnum.Custom);
                this.router.navigate([AppUrls.landing]);
              }
              // else {
              //   this.msalService.logout();
              //   // this.authService.goToLogin();
              // }
            });
          // this.router.navigate([AppUrls.landing]);
    
        });
    
        this.broadcastService.subscribe('msal:loginFailure', () => {
          // Most cases will be because login popup dismissed or blocked from browser
          this.authService.goToLogin();
        });
    
        this.broadcastService.subscribe('msal:acquireTokenFailure', () => {
          // Go login page to refresh
          if (this.authService.getAuthType() === AuthTypeEnum.OIDC) {
            this.authService.goToLogin();
          }
        });
    
        this.msalService.handleRedirectCallback((authError, response) => {
          if (authError) {
            console.error('Redirect Error: ', authError.errorMessage);
            return;
          }
    
          console.log('Redirect Success: ', response);
        });
    
        this.msalService.setLogger(new Logger((logLevel, message, piiEnabled) => {
          console.log('MSAL Logging: ', message);
        }, {
          correlationId: CryptoUtils.createNewGuid(),
          piiLoggingEnabled: false
        }));
    */
    this.router.events.subscribe((event): void => {
      if (event instanceof RouteConfigLoadStart) {
        this.alertsService.showLoader();
      } else if (event instanceof RouteConfigLoadEnd) {
        this.alertsService.hideLoader();
      }
    });

    if (localStorage.getItem('sessionEnded') == 'sessionEnded') {
      this.authService.logout();
    }
  }
  /* #endregion */

  /* #region  Methods */
  checkoutAccount() {
    this.loggedIn = false;
    if (this.authService.isAuthenticated()) {
      this.loggedIn = true;
      this.authService.setAuthType(AuthTypeEnum.Custom);
    } else {
      const account = this.msalService.getLogger();
      if (account) {
        this.loggedIn = true;
        this.authService.setAuthType(AuthTypeEnum.OIDC);
      }
    }
  }
  /* #endregion */

  /* #region  Session Time out */
  initializeSession() {
    localStorage.setItem('clearSessionNow', 'clearSessionNow');
    localStorage.removeItem('clearSessionNow');
    this.cleanTimerSettings();
    this.startTimer();
  }

  cleanTimerSettings() {
    // if (this.idleTimeInMinutes <= this.totalIdleTimeForUser)
    this.idleTimeInMinutes = 0;

    this.maxIdleTime = environment.maxIdleTime as any;
    if (this.timerInterval) {
      this.stopTimer();
      this.showSessionTimeOutPopPup = false;
    }
  }

  startTimer() {
    this.timerInterval = workerTimers.setInterval(() => {
      this.timerIncrement();
    }, 60000);

    document.onmousedown = () => {
      if (this.idleTimeInMinutes < this.maxIdleTime) {
        this.initializeSession();
      }
    };
    document.onkeypress = () => {
      if (this.idleTimeInMinutes < this.maxIdleTime) {
        this.initializeSession();
      }
    };
  }

  private stopTimer() {
    workerTimers.clearInterval(this.timerInterval);
    document.onmousedown = null;
    document.onkeypress = null;
  }

  private timerIncrement() {
    // if (this.idleTimeInMinutes < this.maxIdleTime) {
    //   this.idleTimeInMinutes++;
    // }

    if (this.idleTimeInMinutes >= this.maxIdleTime) {
      if (this.authService.isAuthenticated()) {
        if (this.router.url.toLowerCase().indexOf(AppUrls.login.toLowerCase()) < 0) {
          this.showSessionTimeOutPopPup = true;
        }
        Swal.close();
      }
    }
  }

  logout() {
    this.authService.logout();
  }

  onSessionEnded() {
    this.authService.endSession();
  }
  /* #endregion */
}
